import React, { useState } from "react";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export default function Checkout() {
  const { items, subtotal, clear } = useCart();
  const { user } = useAuth();
  const [addr, setAddr] = useState({ name: user?.name || "", street: "", city: "", zip: "", country: user?.country || "IT" });
  const [loading, setLoading] = useState(false);

  const proceed = async () => {
    if (items.length === 0) return toast.error("Carrello vuoto");
    setLoading(true);
    try {
      const r = await api.post("/payments/checkout", {
        items: items.map(i => ({ product_id: i.product_id, product_type: i.product_type, quantity: i.quantity, unit: i.unit })),
        origin_url: window.location.origin,
        shipping_address: addr,
      });
      // don't clear yet; only on successful redirect back
      window.location.href = r.data.url;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore checkout");
      setLoading(false);
    }
  };

  const shipping = subtotal > 80 ? 0 : 7.90;
  const total = subtotal + shipping;

  return (
    <div data-testid="checkout-page" className="container-xl py-12">
      <h1 className="editorial-heading text-5xl md:text-6xl">Checkout</h1>
      <div className="mt-10 grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-6">
          <div className="bg-card border border-border rounded-sm p-6">
            <div className="text-xs font-bold uppercase tracking-[0.2em] mb-4">Indirizzo di spedizione</div>
            <div className="grid md:grid-cols-2 gap-3">
              <Input data-testid="shipping-name" placeholder="Nome completo" value={addr.name} onChange={e => setAddr({ ...addr, name: e.target.value })} />
              <Input data-testid="shipping-street" placeholder="Via e numero" value={addr.street} onChange={e => setAddr({ ...addr, street: e.target.value })} />
              <Input data-testid="shipping-city" placeholder="Città" value={addr.city} onChange={e => setAddr({ ...addr, city: e.target.value })} />
              <Input data-testid="shipping-zip" placeholder="CAP" value={addr.zip} onChange={e => setAddr({ ...addr, zip: e.target.value })} />
              <Input data-testid="shipping-country" placeholder="Paese" value={addr.country} onChange={e => setAddr({ ...addr, country: e.target.value })} />
            </div>
          </div>
          <div className="bg-card border border-border rounded-sm p-6">
            <div className="text-xs font-bold uppercase tracking-[0.2em] mb-4">I tuoi articoli</div>
            {items.length === 0 ? (
              <div className="text-muted-foreground">Il carrello è vuoto. <Link to="/box" className="text-[hsl(var(--primary))] underline">Vai allo shop</Link></div>
            ) : (
              <div className="space-y-3">
                {items.map(i => (
                  <div key={`${i.product_id}-${i.unit}`} className="flex items-center gap-3 text-sm border-b border-border pb-2">
                    {i.image && <img src={i.image} alt="" className="w-12 h-12 object-cover rounded-sm" />}
                    <div className="flex-1">
                      <div className="font-medium">{i.name}</div>
                      <div className="text-xs text-muted-foreground">{i.quantity} × €{i.unit_price.toFixed(2)} / {i.unit}</div>
                    </div>
                    <div className="font-semibold">€{(i.unit_price * i.quantity).toFixed(2)}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="h-fit bg-card border border-border rounded-sm p-6 space-y-3">
          <div className="text-xs font-bold uppercase tracking-[0.2em] mb-2">Riepilogo</div>
          <div className="flex justify-between text-sm"><span>Subtotale</span><span>€{subtotal.toFixed(2)}</span></div>
          <div className="flex justify-between text-sm"><span>Spedizione</span><span>{shipping === 0 ? "Gratis" : `€${shipping.toFixed(2)}`}</span></div>
          <div className="border-t border-border pt-3 flex justify-between text-lg font-bold"><span>Totale</span><span className="text-[hsl(var(--primary))]">€{total.toFixed(2)}</span></div>
          <Button
            data-testid="pay-btn"
            onClick={proceed}
            disabled={loading || items.length === 0}
            className="w-full bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90 rounded-sm"
            size="lg"
          >
            {loading ? "Reindirizzamento…" : "Paga con Stripe"}
          </Button>
          <div className="text-xs text-muted-foreground">Pagamento sicuro con Stripe. Carte supportate: Visa, Mastercard, Amex.</div>
        </div>
      </div>
    </div>
  );
}
